import React, { useState, useEffect } from 'react'
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useLocation } from "react-router-dom";
import { TableWrapper, TableSection, Header, SearchWrapper } from '../dashBoardStyled'
//table
import { Table } from 'reactstrap';
import CsvDownloader from 'react-csv-downloader';

function UserSubscriptionList(props) {
    const location = useLocation();
    const [tableData, setTableData] = useState([])
    const [headerCheck, setHeaderCheck] = useState(false)
    const [csvData, setCsvData] = useState([])
    if (props.userData) {
        tableData = props.userData
    }
    let headerArr = [
        { title: 'Company/Location Name', },
        { title: 'Address', },
        { title: 'Subscription Status', }
    ];

    //for csv download
    const columns = [
        { id: 'Name', displayName: 'Company/Location Name' },
        { id: 'Address', displayName: 'Address' },
        { id: 'SubscriptionStatus', displayName: 'Subscription Status' },
        { id: 'Email', displayName: 'Email' }
    ]

    useEffect(() => {
        if (location.state !== undefined || JSON.parse(sessionStorage.getItem('userSubData')) !== null) {
            let tempData = []
            if (location.state !== undefined) {
                tempData = location.state.data
                sessionStorage.setItem('userSubData', JSON.stringify(tempData))
            } else if (JSON.parse(sessionStorage.getItem('userSubData')) !== null) {
                tempData = JSON.parse(sessionStorage.getItem('userSubData'))
            }
            tempData = tempData.map(data => ({ ...data, checked: false }))
            setTableData(tempData)

            //set csv data
            let tempCsvData = tempData.map(val => {
                return ({
                    Name: val.locationName,
                    Address: `${val.address.city?.replaceAll(","," ")} -${val.address.state}`,
                    SubscriptionStatus: val.subscriptionStatus,
                    Email: ''
                })
            })
            setCsvData(tempCsvData)
        }
    }, [location]);

    return (
        <div>
            <TableWrapper>
                <Header style={{ height: '55px' }}>
                    <h3>Subscribers List</h3>
                    <SearchWrapper style={{ justifyContent: 'flex-end' }}>
                        <CsvDownloader
                            filename="Subscribers List"
                            columns={columns}
                            datas={csvData}>
                            <button
                                style={{ color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '5px' }}>
                                Download
                            </button>
                        </CsvDownloader>
                    </SearchWrapper>


                </Header>
                <TableSection>
                    <Table responsive>
                        <thead>
                            <tr>
                                {headerArr.map((items, index) => (
                                    <th key={index}>{items.title}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                tableData.map((items, index) => (
                                    <tr key={index}>
                                        <td>{items.locationName}</td>
                                        <td>{`${items.address.city} ${items.address.state}`}</td>
                                        <td>{items.subscriptionStatus}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                </TableSection>
            </TableWrapper>
        </div>
    )

}

export default UserSubscriptionList